import { reactiveSetArray, set } from '../../../services/util/store.helper';
import HourService from '../../../services/api/hour.service';

export default {
  namespaced: true,
  state: {
    loading: false,
    serverTime: null,
    currentShift: null,
    selectedCell: null,
    currentDate: null,
    yestedayworstpart: [],
    machines: [],
    cells: [],
    shifts: [],
    userId: '',
    customerId: '',
    username: '',
    dataFromJSON: false,
    intervalfetch: 50,
    planParts: [],
    theme: {
      isDark: true,
      themes: {
        dark: {
          cardbg: '#15191E',
          subtitlecolor: '#A1A3A5',
          titlecolor: '#FFFFFF',
          error: '#ED5353',
          success: '#21C77C',
        },
        light: {
          cardbg: '#FFFFFF',
          subtitlecolor: '#333333',
          titlecolor: '#15191E',
          error: '#FF5252',
          success: '#21C77C',
        },
      },
    },
  },

  mutations: {
    setLoading: set('loading'),
    setServerTime: set('serverTime'),
    setCurrentShift: set('currentShift'),
    setCurrentDate: set('currentDate'),
    setSelectedCell: set('selectedCell'),
    setMachines: set('machines'),
    setMachine: reactiveSetArray('machines'),
    setCells: set('cells'),
    setShifts: set('shifts'),
    setWorstPart: set('yestedayworstpart'),
    setPlanParts: set('planParts'),

    setTheme: set('theme'),
    setUserId: set('userId'),
    setCustomerId: set('customerId'),
    setUsername: set('username'),
    setDataFromJSON: set('dataFromJSON'),
    setIntervalFetch: set('intervalfetch'),
  },

  actions: {
    getServerTime: async ({ commit }) => {
      try {
        const { data } = await HourService.getCurrentTime();
        if (data && data.results) {
          commit('setServerTime', data.results);
          return data.results;
        }
        return false;
      } catch (e) {
        return false;
      }
    },

    getBusinessTime: async ({ commit, dispatch }) => {
      const serverTime = await dispatch('getServerTime');
      if (serverTime) {
        const data = await dispatch(
          'calendar/getBusinessTime',
          serverTime,
          { root: true },
        );
        if (data) {
          commit('setCurrentShift', data.shiftName);
          commit('setCurrentDate', +data.date);
          return true;
        }
      }
      return false;
    },

    getShifts: async ({ commit, dispatch }) => {
      const records = await dispatch(
        'element/getRecords',
        {
          elementName: 'businesshours',
          query: '?sortquery=sortindex==1',
        },
        { root: true },
      );
      if (records && records.length) {
        commit('setShifts', records);
        return records;
      }
      return [];
    },

    allShifts: async ({ dispatch, commit }) => {
      try {
        const records = await dispatch(
          'element/getRecords',
          { elementName: 'businesshours', query: '?sortquery=sortindex==1' },
          { root: true },
        );
        if (records && records.length) {
          commit('setShifts', records);
          return records;
        }
        return false;
      } catch (e) {
        return false;
      }
    },

    getMachines: async ({ dispatch, commit }, query) => {
      try {
        const records = await dispatch(
          'element/getRecords',
          { elementName: 'machine', query },
          { root: true },
        );
        if (records && records.length) {
          commit('setMachines', records);
          const extractedCells = [...new Set(records.map((m) => m.machinecell).filter(Boolean))];
          commit('setCells', extractedCells);
          return records;
        }
        return false;
      } catch (e) {
        return false;
      }
    },

    getReports: async ({ dispatch }, { reportName, payload }) => {
      try {
        const data = await dispatch(
          'report/executeReport',
          { reportName, payload },
          { root: true },
        );
        if (data && data.reportData) {
          return data.reportData;
        }
        return data || false;
      } catch (e) {
        return false;
      }
    },
    getFeedbackImg: async ({ dispatch }, query) => {
      try {
        const records = await dispatch(
          'element/getRecords',
          { elementName: 'sopfiles', query },
          { root: true },
        );
        return records;
      } catch (e) {
        return false;
      }
    },

    getCriticalPart: async ({ dispatch }, query) => {
      try {
        const records = await dispatch(
          'element/getRecords',
          { elementName: 'criticalpart', query },
          { root: true },
        );
        return records;
      } catch (e) {
        return false;
      }
    },

    getRecords: async ({ dispatch }, { elementName, query }) => {
      try {
        const records = await dispatch(
          'element/getRecords',
          { elementName, query },
          { root: true },
        );
        return records;
      } catch (e) {
        return false;
      }
    },

    createRecord: async ({ dispatch }, payload) => {
      try {
        const record = await dispatch('element/postRecord', {
          elementName: 'criticalpart',
          payload,
        }, { root: true });

        return record;
      } catch (e) {
        return false;
      }
    },

    updateRecord: async ({ dispatch }, payload) => {
      try {
        const record = await dispatch(
          'element/updateRecordById',
          { elementName: 'criticalpart', id: payload.id, payload: payload.elementData },
          { root: true },
        );
        return record;
      } catch (e) { return false; }
    },
    getFile: async ({ dispatch }, downloadLink) => {
      const records = await dispatch(
        'file/downloadMedia',
        downloadLink,
        { root: true },
      );
      if (records) {
        return window.URL.createObjectURL(records);
      }
      return false;
    },
    postFileData: async ({ commit, dispatch }, { filePayload, elementData }) => {
      const records = await dispatch(
        'element/uploadFiles',
        {
          elementName: 'sopfiles',
          payload: filePayload,
        },
        { root: true },
      );
      if (records && records.id) {
        dispatch('updateData', { id: records.id, elementData });
      } else {
        commit('helper/setAlert', {
          show: true,
          type: 'error',
          message: 'CELLWISE_UPLOAD_ERROR',
        }, {
          root: true,
        });
      }
    },
    updateData: async ({ commit, dispatch }, { id, elementData }) => {
      const { partname, cellName } = elementData;
      const payload = {
        partname,
        cellname: cellName,
        widget: 'Quality Feedback',
      };

      const records = await dispatch(
        'element/updateRecordById',
        {
          elementName: 'sopfiles',
          id,
          payload,
        },
        { root: true },
      );

      if (records) {
        commit('helper/setAlert', {
          show: true,
          type: 'success',
          message: 'FILE_UPLOAD_SUCCESS',
        }, { root: true });
      } else {
        commit('helper/setAlert', {
          show: true,
          type: 'error',
          message: 'CELLWISE_UPDATE_ERROR',
        }, { root: true });
      }
    },
    deleteFile: async ({ dispatch }, id) => {
      const deleteParameter = await dispatch(
        'element/deleteRecordById',
        {
          elementName: 'sopfiles',
          id,
        },
        { root: true },
      );
      return deleteParameter;
    },
  },

  getters: {
    activeSite: (state, getters, rootState) => {
      let site = rootState.user?.activeSite || rootState.auth?.user?.site_id;

      if (!site) {
        try {
          const swxUser = JSON.parse(localStorage.getItem('user') || '{}');
          site = swxUser?.site_id
            || swxUser?.site?.id || swxUser?.customer?.site_id || swxUser?.activeSiteId;
        } catch (e) { /* ignore */ }
      }

      if (!site && state.machines && state.machines.length > 0) {
        site = state.machines[0].siteId || state.machines[0].siteid;
      }

      return site;
    },

    filteredMachines: ({ machines, selectedCell }) => {
      if (selectedCell) return machines.filter((m) => m.machinecell === selectedCell);
      return machines;
    },

    machinenames: (state) => state.machines.map((m) => m.machinename),

    shiftdate: (state) => {
      if (!state.currentDate) return '';
      const dateStr = state.currentDate.toString();
      if (dateStr.length === 8) {
        return `${dateStr.substring(0, 4)}-${dateStr.substring(4, 6)}-${dateStr.substring(6, 8)}`;
      }
      return dateStr;
    },

    firstShift(state) {
      if (state.shifts && state.shifts.length) {
        return state.shifts[0];
      }
      return null;
    },

    activeTheme(state) {
      return (state.theme && state.theme.isDark) ? 'dark' : 'light';
    },
  },
};
